import { GlobalContext } from "global/context/Provider";
import camelize from "global/utils/camelize";
import { useContext, useEffect, useState } from "react";
import { useHistory } from "react-router";
import MiTurnoIcon from "_+_Portal/assets/images/generico/MiTurnoIcon";
import { OtrosTramites } from "_+_Portal/assets/images/generico/OtrosTramites";
import { PortalContext } from "_+_Portal/context/Provider";
import BtnLink from "_+_Portal/_-_Autocheckin/components/genericos/BtnLink/BtnLink";
import LayoutPasos from "_+_Portal/_-_Autocheckin/components/genericos/LayoutPasos/LayoutPasos";
import { setPaso } from "_+_Portal/_-_Autocheckin/context/action/paso";
import { AutocheckContext } from "_+_Portal/_-_Autocheckin/context/Provider";
import TildeOk from "../../../assets/images/generico/TildeOk";
import { BtnContainer, ContainerHomeLabo } from "./localStyle";
import { wsGetTurnosPacienteDelDia } from "_+_Portal/_-_Autocheckin/context/action/turnosAutoCheckIn";
import Loading from "_+_Portal/components/Genericos/Loading/Loading";
import { setTurnosSeleccionado } from "_+_Portal/_-_Autocheckin/context/action/turnosSeleccionados";
import { OrderTurnosLabo } from "../PagesFun";

const HomeLabo = ({ setPasoSelectFamiliar }) => {
  //#region -------------------------  context ----------------------------
  const { authState } = useContext(GlobalContext);
  const { selectDropDownState } = useContext(PortalContext);
  const {
    pasoDispatch,
    turnosAutoCheckInDispatch,
    turnosSeleccionadosDispatch,
    textosAutoCheckinState,
    ubicacionState,
  } = useContext(AutocheckContext);
  //#endregion -------------------------  context ----------------------------

  //#region ------------------------ states ----------------------------
  const [loading, setLoading] = useState(true);
  const [isPresent, setIsPresent] = useState(false);
  //#endregion --------------------- states ----------------------------

  //#region -------------------------  constantes ----------------------------
  const pacienteNombre = selectDropDownState?.selectDropDown?.selectGlobal
    ?.pacienteElegido?.paciente?.nombre
    ? selectDropDownState?.selectDropDown?.selectGlobal?.pacienteElegido?.paciente
        ?.nombre
    : authState?.auth?.data?.paciente?.nombre ?? "";
  const history = useHistory();
  const idPacFamiliar = selectDropDownState?.selectDropDown?.selectGlobal
    ?.pacienteElegido?.paciente?.codigo
    ? selectDropDownState?.selectDropDown?.selectGlobal?.pacienteElegido?.paciente
        ?.codigo
    : false;
  const config = localStorage.getItem("config");
  const filtroHorario =
    textosAutoCheckinState.textosAutoCheckin?.data?.filtroHorario?.orden;
  let parsedConfig = {};
  try {
    parsedConfig = JSON.parse(config) ?? {};
  } catch (e) {
    parsedConfig = {};
  }
  const opcMisLaboratorios = parsedConfig?.opcMisLaboratorios;
  const minutosToleranciaRecepcion = parsedConfig?.minutosToleranciaRecepcion;
  const minRecepcionVariosTurnos = parsedConfig?.minRecepcionVariosTurnos;
  const coordenadas = ubicacionState?.ubicacion?.data;
  //#endregion -----------------------  constantes ----------------------------

  //#region -------------------------  functions ----------------------------

  const tengoTurno = () => {
    setPasoSelectFamiliar("TurnosDelDiaLabo");
    setPaso("TurnosDelDiaLabo")(pasoDispatch);
  };
  const necesitoTurno = () => {
    setPasoSelectFamiliar("laboratorio");
    setPaso("SelectFamiliar")(pasoDispatch);
  };
  const atencionSinTurno = () => {
    history.push("/atencionSinTurno");
  };
  const resultados = () => {
    history.push("/misLaboratorios");
  };
  const handleVolver = () => {
    setPaso("Home")(pasoDispatch);
  };
  const nextStepTurnosList = (isCorrect, data) => {
    if (isCorrect && Array.isArray(data)) {
      data = data.filter((turno) => turno.idProtocolo); // Este filtro es necesario
      const turnosOrdenados = OrderTurnosLabo(
        data,
        filtroHorario,
        minutosToleranciaRecepcion,
        minRecepcionVariosTurnos,
        coordenadas,
      );

      const turnosPresentes = turnosOrdenados.filter(
        (turno) => turno.estadoProtocolo === 4 && turno.type === "laboratorio",
      );
      if (turnosPresentes.length > 0) {
        setIsPresent(true);
        setTurnosSeleccionado(turnosOrdenados)(turnosSeleccionadosDispatch);
      }
      setLoading(false);
    }
  };

  const tengoTurnoPresente = () => {
    setPaso("TurnosConPresente")(pasoDispatch);
  };
  //#endregion -------------------------  functions ----------------------------

  //#region ------------------------ useEffects ----------------------------

  useEffect(() => {
    if (loading) {
      wsGetTurnosPacienteDelDia(
        idPacFamiliar,
        nextStepTurnosList,
      )(turnosAutoCheckInDispatch);
    }
  }, []);

  //#endregion --------------------- useEffects ----------------------------
  return (
    <>
      {loading ? (
        <Loading
          dataLoading={loading}
          color="c-white"
          descripcion={"Cargando turnos de laboratorio..."}
        />
      ) : (
        <LayoutPasos
          volverTo={handleVolver}
          title={camelize(pacienteNombre)}
          subtitle={"LABORATORIO"}
        >
          <ContainerHomeLabo
            initial={{ opacity: 0, y: +100 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 100 }}
            transition={{ duration: 0.4 }}
          >
            <BtnContainer>
              {isPresent ? (
                <BtnLink
                  Icon={<TildeOk color={"var(--color-primary)"} />}
                  type={"GREEN"}
                  title={"YA RECEPCIONADOS"}
                  onclick={tengoTurnoPresente}
                />
              ) : (
                <BtnLink
                  Icon={<TildeOk color={"var(--color-primary)"} />}
                  type={"NORMAL"}
                  title={"TENGO TURNO"}
                  onclick={tengoTurno}
                />
              )}
              <BtnLink
                Icon={<MiTurnoIcon color={"var(--color-primary)"} />}
                type={"NORMAL"}
                title={"NECESITO UN TURNO"}
                onclick={necesitoTurno}
              />
              <BtnLink
                Icon={<OtrosTramites color={"var(--color-primary)"} />}
                type={"NORMAL"}
                title={"ATENCIÓN SIN TURNO"}
                onclick={atencionSinTurno}
              />
              {opcMisLaboratorios && (
                <BtnLink
                  Icon={<OtrosTramites color={"var(--color-primary)"} />}
                  type={"NORMAL"}
                  title={"RESULTADOS"}
                  onclick={resultados}
                />
              )}
            </BtnContainer>
          </ContainerHomeLabo>
        </LayoutPasos>
      )}
    </>
  );
};

export default HomeLabo;
